






















































import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { loggerFor } from '@/shared/utils/logger'
import { htmlToText } from '@/shared/utils/html-to-text'
import { FormControl, FormGroup, ValidationErrors } from '@tf/forms'

@Component({
  inject: ['form'],
})
export default class TfValidationFeedback extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly control!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly validatePristine!: boolean

  public readonly form!: FormGroup<any>

  private logger = loggerFor(`ValidationFeedback ${this.control}`)

  get dirty() {
    return this.validatePristine === true || (this.formControl.dirty && this.formControl.touched)
  }

  get error(): boolean {
    return this.formControl.valid === false
  }

  get model(): string {
    return this.formControl.value
  }

  get formControl(): FormControl<any> {
    return this.form.get(this.control)
  }

  public getError(validatorName: string): ValidationErrors {
    let error: ValidationErrors = null

    if (this.formControl.errors) {
      error = this.formControl.errors[validatorName]
    }

    return error
  }

  /**
   * Check if the given validator has been defined and is currently invalid
   */
  public hasError(validatorName: string): boolean {
    return this.getError(validatorName) != null
  }

  public htmlLength(model: string): number {
    return htmlToText(model).length
  }
}
